import { render, staticRenderFns } from "./TrangSuaChucVu.vue?vue&type=template&id=0a04d14a&"
import script from "./TrangSuaChucVu.vue?vue&type=script&lang=js&"
export * from "./TrangSuaChucVu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports